let Config = 1;

function importConfig(config, onLoaded = () => 0) {
  Config = config;
  this.$store.commit('SetStrings', Config.strings);
  this.$store.commit('SetPathways', Config.pathways);
  this.$store.commit('SetReferences', Config.references);
  this.$store.commit('SetSections', Config.sections);
  this.$store.commit('SetSection', 0);
  this.$store.commit('SetVideos', Config.videos);
  onLoaded();
}

function getString(key) {
  const strings = this.$store.getters.strings;
  let string = (key in strings) ? strings[key] : '';
  return string ? string : key;
}

function install(Vue) {
  Vue.prototype.$importConfig = function(configPath, onLoaded) {
    fetch(configPath)
      .then(response => response.json())
      .then(data => importConfig.call(this, data, onLoaded));
  };
  Vue.prototype.$reloadConfig = function() {
    importConfig.call(this, Config);
  };
  Vue.prototype.$getString = function (key) {
    return key[0] === '!' ? key : getString.call(this, key);
  };
}

export default { install };
